import * as React from 'react';
import { useEffect } from 'react';

import './LastEvents.scss';
import { useTranslate } from 'react-polyglot';
import { Card } from 'react-bootstrap';
import PageTable from '../../Shared/PageTable/PageTable';


function LastEvents() {
    const t = useTranslate();

    useEffect(() => {
        
    }, []);

    return (
        <div className="maincontent">
            <div className="lastevents-container">
                <div className="pagetitle-container">
                    <h1>{t("events.events_page_name")}</h1>
                </div>
                <Card>
                    <Card.Body>
                        <PageTable
                            dataUrl={"/api/events/getAllPaged/"}
                            options={{
                                showFields: [
                                    { label: t("events.table_colnametype"), field: "type", override: dataLine => dataLine["type"] != undefined ? t(dataLine["type"]) : ""},
                                    { label: t("events.table_colnamechange"), field: "comment",  override: dataLine => dataLine["comment"] != undefined ? t(dataLine["comment"]) : ""},
                                    { label: t("events.table_colnamedesc"), field: "description", override: dataLine => dataLine["description"] != undefined ? (t(dataLine["description"].split("|")[0]) + " " + dataLine["description"].split("|")[1]) : "", maxLength: 100},
                                    { label: t("events.table_colnameuser"), field: "username"},
                                    { label: t("events.table_colnameorg"), field: "orgname"},
                                    { label: t("events.table_colname_updatedfield"), field: "updatedField"},
                                    { label: t("events.table_colname_valuebefore"), field: "valueBefore", maxLength: 100},
                                    { label: t("events.table_colname_valueafter"), field: "valueAfter", maxLength: 100},
                                    { label: t("events.table_colnametime"), field: "dateReadable"}
                                ],
                                pageSize: 15
                            }}
                            deaultSortDirection={"desc"}
                            defaultSortField={"dateReadable"}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            hover={false}
                        />
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}
 
export default LastEvents;